module.exports = __webpack_public_path__ + "img/CS-Profi-Assembly.90a10185.jpg";